import { render, staticRenderFns } from "./JLzhTable.vue?vue&type=template&id=f14029f2&scoped=true"
import script from "./JLzhTable.vue?vue&type=script&lang=js"
export * from "./JLzhTable.vue?vue&type=script&lang=js"
import style0 from "./JLzhTable.vue?vue&type=style&index=0&id=f14029f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14029f2",
  null
  
)

export default component.exports